import { useCallback, useEffect, useState } from 'react'
import { BreakpointSize, BreakpointPosition } from '@/shared/Types/Cura'

const checkIsActiveBreakPoint = (maxMobileSize: number) => {
  const { width: screenWidth } =
    document.documentElement.getBoundingClientRect()
  const isInRange = screenWidth <= maxMobileSize

  return isInRange
}

export const useIsActiveBreakPoint = (
  size: BreakpointSize,
  position: BreakpointPosition = 'max'
) => {
  const maxBreakpointSize = window.CuraAPI?.theme.breakpoints.get(
    size,
    position
  )

  const [isActiveBreakpoint, setIsActiveBreakpoint] = useState(() =>
    checkIsActiveBreakPoint(maxBreakpointSize)
  )

  const handleWindowResize = useCallback(() => {
    const isBreakpoint = checkIsActiveBreakPoint(maxBreakpointSize)

    if (isActiveBreakpoint === isBreakpoint) {
      return
    }

    setIsActiveBreakpoint(isBreakpoint)
  }, [isActiveBreakpoint, maxBreakpointSize])

  const startListenWindowResize = useCallback(() => {
    window.addEventListener('resize', handleWindowResize)
  }, [handleWindowResize])

  const cleanUp = useCallback(() => {
    window.removeEventListener('resize', handleWindowResize)
  }, [handleWindowResize])

  useEffect(() => {
    startListenWindowResize()

    return cleanUp
  }, [cleanUp, startListenWindowResize])

  return isActiveBreakpoint
}
